<template>
  <div class="more-nav-c" @click="handleCancel" @touchend="handleCancel">
    <div class="main" @click.stop @touchend.stop>
      <!-- 功能按钮 -->
      <div class="group-btns">
        <template v-for="btn in btnList">
            <div class="item" :key="btn.type" @click="handleEvent(btn)">
              <div class="icon-container">
                <img :src="btn.icon" />
              </div>
              <span>{{ btn.name }}</span>
            </div>
        </template>
      </div>
      <div class="cancel-btn" @click="handleCancel">取消</div>
    </div>
  </div>
</template>
<script>
export default {
  props: [],
  data() {
    return {
      btnList: [
        {
          type: "allnav",
          name: "全站导航",
          icon: "//statics.itc.cn/WAP_base/icon_menu_empty4@2x.png",
        },
        {
          type: "fb",
          name: "反馈",
          icon: "//statics.itc.cn/mp/article-page/wap/prod/images/icon_feedback_empty4@2x-af5a89.png",
          url: `//m.sohu.com/feedback?page=function&fburl=${encodeURIComponent(window.location.href)}`,
        },
      ],
    };
  },
  methods: {
    handleCancel(type) {
      this.$emit("close", { status: false, type: type });
    },
    handleEvent(btnInfo) {
        const type = btnInfo?.type
        switch (type) {
        case "allnav":
            this.handleCancel(type);
            break;
        case "fb":
            window.location.href = btnInfo?.url
            this.handleCancel(type);
            break;
        }
    },
  },
};
</script>
<style lang="less" scoped>
.more-nav-c {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  .main {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    .group-btns {
      padding: 40px 24px 4px; /*px*/
      height: 220px; /*px*/
      box-sizing: border-box;
      background: #f5f5f5;
      display: flex;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 114px; /*px*/
        .icon-container {
          width: 92px; /*px*/
          height: 92px; /*px*/
          background: white;
          border-radius: 50%;
          margin-bottom: 20px; /*px*/
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 50px; /*px*/
            height: 50px; /*px*/
          }
        }
      }
    }
    .cancel-btn {
      height: 100px; /*px*/
      font-size: 32px; /*px*/
      line-height: 100px; /*px*/
      text-align: center;
      color: #3c3c3d;
      background: white;
    }
  }
}
</style>


